export const deletionRequestsSk = {
  // Direct translations for deletion types and statuses
  USER_ACCOUNT: 'Používateľský účet',
  TENANT_COMPANY: 'Spoločnosť',

  // Status translations
  PENDING: 'Čaká sa',
  PROCESSING: 'Spracúva sa',
  COMPLETED: 'Dokončené',
  FAILED: 'Neúspešné',

  // Common translations
  common: {
    cancel: 'Zrušiť'
  },

  // Pages structure for settings
  pages: {
    settings: {
      deletionRequests: {
        title: 'Vymazanie účtu',
        description: 'Spravujte žiadosti o vymazanie účtu a spoznajte našu politiku uchovávania údajov. Všetky žiadosti o vymazanie majú 30-dňové spracovanie, počas ktorého môžete žiadosť zrušiť.',
        deleteAccount: {
          title: 'Vymazať účet',
          description: 'Odoslať žiadosť o vymazanie vášho účtu a všetkých súvisiacich údajov po 30-dňovom spracovaní.',
          warning: 'Po odoslaní začne 30-dňové spracovanie skôr, ako sa akékoľvek údaje vymažú. Žiadosť môžete zrušiť počas tohto času.',
          activeRequestWarning: 'Už máte aktívnu žiadosť o vymazanie účtu. Počkajte, kým bude spracovaná.',
          button: 'Vymazať účet'
        },
        existingRequests: {
          title: 'Vaše žiadosti o vymazanie',
          loading: 'Načítavajú sa žiadosti o vymazanie...',
          empty: 'Nenašli sa žiadne žiadosti o vymazanie',
          accountDeletion: 'Žiadosť o vymazanie účtu',
          requestedAt: 'Požiadané',
          completedAt: 'Dokončené',
          type: 'Typ',
          verified: 'Overená totožnosť',
          yes: 'Áno',
          no: 'Nie',
          cancel: 'Zrušiť žiadosť'
        },
        status: {
          PENDING_VERIFICATION: 'Čaká na overenie',
          VERIFIED: 'Overené',
          IN_PROGRESS: 'Spracúva sa',
          COMPLETED: 'Dokončené',
          REJECTED: 'Zamietnuté',
          CANCELLED: 'Zrušené',
          pending: 'Čaká sa',
          processing: 'Spracúva sa',
          completed: 'Dokončené',
          failed: 'Neúspešné'
        },
        types: {
          user_account: 'Používateľský účet',
          tenant_company: 'Spoločnosť'
        }
      }
    }
  },

  // Modal translations
  modals: {
    deleteAccount: {
      title: 'Vymazať účet',
      warning: 'Týmto odošlete žiadosť o vymazanie, ktorá začne 30-dňové spracovanie.',
      irreversible: 'Nič sa nevymaže okamžite. Máte 30 dní na zrušenie tejto žiadosti pred začatím mazania údajov.',
      processingInfo: {
        title: 'Informácie o procese vymazania',
        period: '30-dňové spracovanie začne po odoslaní žiadosti',
        cancellation: 'Žiadosť môžete zrušiť kedykoľvek počas 30-dňového obdobia',
        finalDeletion: 'Po 30 dňoch budú údaje natrvalo vymazané'
      },
      dataInfo: {
        title: 'Čo sa stane s vašimi údajmi?',
        deletedAfter30Days: 'Údaje vymazané po 30-dňovom spracovaní:',
        retainedPseudonymized: 'Údaje zachované (pseudonymizované) pre právne požiadavky:',
        deletedAfter30DaysItems: {
          personalInfo: 'Meno, email, telefón, adresa',
          cvAttachments: 'Životopis a prílohy',
          notesRatings: 'Poznámky a hodnotenia',
          profileData: 'Údaje profilu'
        },
        retainedItems: {
          applicationData: 'Dátumy žiadostí a pozície',
          auditLogs: 'Audit záznamy',
          consentRecords: 'Záznamy súhlasov',
          technicalLogs: 'IP adresy a technické záznamy',
          period6months: '6 mesiacov',
          period12months: '12 mesiacov',
          period24months: '24 mesiacov'
        }
      },
      reason: {
        label: 'Dôvod vymazania (voliteľné)',
        placeholder: 'Povedzte nám, prečo si mažete účet...',
        hint: 'Pomáha nám to zlepšiť naše služby'
      },
      password: {
        label: 'Potvrďte svoje heslo',
        placeholder: 'Zadajte svoje súčasné heslo',
        hint: 'Potrebné na overenie vašej totožnosti'
      },
      confirmation: {
        instruction: 'Napíšte \'DELETE\' veľkými písmenami pre potvrdenie:',
        label: 'Potvrdenie',
        valid: 'Potvrdzovací text je správny',
        invalid: 'Prosím napíšte \'DELETE\' presne ako je ukázané'
      },
      finalConfirmation: 'Rozumiem, že týmto začne 30-dňové spracovanie a žiadosť môžem zrušiť počas tohto času',
      deleteButton: 'Vymazať môj účet'
    },
    deleteCompany: {
      title: 'Vymazať spoločnosť',
      warning: 'Týmto odošlete žiadosť o vymazanie celej spoločnosti, ktorá začne 30-dňové spracovanie.',
      irreversible: 'Nič sa nevymaže okamžite. Máte 30 dní na zrušenie tejto žiadosti pred začatím mazania údajov spoločnosti.',
      dataInfo: {
        title: 'Čo sa stane s údajmi spoločnosti?',
        deletedAfter30Days: 'Údaje spoločnosti vymazané po 30-dňovom spracovaní:',
        retainedPseudonymized: 'Údaje zachované (pseudonymizované) pre právne požiadavky:'
      },
      reason: {
        label: 'Dôvod vymazania spoločnosti (voliteľné)',
        placeholder: 'Povedzte nám, prečo mažete spoločnosť...',
        hint: 'Pomáha nám to zlepšiť naše služby'
      },
      password: {
        label: 'Potvrďte svoje heslo',
        placeholder: 'Zadajte svoje súčasné heslo',
        hint: 'Potrebné na overenie vašej totožnosti administrátora'
      },
      confirmation: {
        instruction: 'Napíšte \'DELETE COMPANY\' veľkými písmenami pre potvrdenie:',
        label: 'Potvrdenie',
        valid: 'Potvrdzovací text je správny',
        invalid: 'Prosím napíšte \'DELETE COMPANY\' presne ako je ukázané'
      },
      finalConfirmation: 'Rozumiem, že týmto začne 30-dňové spracovanie a žiadosť môžem zrušiť počas tohto času',
      deleteButton: 'Vymazať spoločnosť'
    }
  }
};